import brand from "@helio-shared/brand.json";

export type BrandColors = {
  lime: string;
  mint: string;
  navy: string;
};

export const BRAND = brand as BrandColors;

export const BRAND_LIME = BRAND.lime;
export const BRAND_MINT = BRAND.mint;
export const BRAND_NAVY = BRAND.navy;
